export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts
    .filter((part): part is string => typeof part === 'string' && part.length > 0)
    .join(' ');
}

export function variant(
  base: string,
  values: Record<string, string | number | boolean | undefined>,
): string {
  const applied = Object.entries(values)
    .filter(([, value]) => value !== undefined && value !== false)
    .map(([key, value]) => (value === true ? `${base}--${key}` : `${base}--${value}`));
  return applied.join(' ');
}

export function mergeIds(...ids: Array<string | undefined>): string | undefined {
  const joined = ids
    .filter((id): id is string => typeof id === 'string' && id.length > 0)
    .join(' ');
  return joined.length > 0 ? joined : undefined;
}
